import React from 'react'
import Input from './../input'
import { PROTOCOL, httpauth_src_fields, httpauth_dest_fields } from './../../lib/helper'
import { Form } from 'formsy-react'
import _ from 'underscore'
import qs from 'qs'
import PropTypes from 'prop-types'

const SERVER = {FLEXIBLE: 1, AUTOSCALE: 2}

class CloudwaysForm extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			cwsServer: props.fields['is_autoscale'] ? SERVER.AUTOSCALE : SERVER.FLEXIBLE,
			privacyMode: false,
			sourceSiteInfo: false,
			httpAuth: false,
			tablesInfo: false
		}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
		this.togglePrivacyMode = this.togglePrivacyMode.bind(this)
		this.toggleSourceSiteInfo = this.toggleSourceSiteInfo.bind(this)
		this.toggleHttpAuth = this.toggleHttpAuth.bind(this)
		this.showDirectoryList = this.showDirectoryList.bind(this)
	}

	UNSAFE_componentWillMount(){
		const { errors } = this.props
		this.setAdvancedOptionsError(errors)
		this.setToggle()
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		const { errors } = nextProps
		const olderrors = this.props.errors
		if (!_.isEqual(errors, olderrors)){
			this.setAdvancedOptionsError(errors)
		}
	}

	getLocationQuery() {
		const { history } = this.props
		const { location } = history
		return qs.parse(location.search, {ignoreQueryPrefix: true})
	}

	canEnableCwsAutoscale = () => {
		const { cwsAutoscaleEnabled } = this.props
		return cwsAutoscaleEnabled || this.getLocationQuery().autoscale
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key){
		const { errors } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	setToggle() {
		const { fields } = this.props
		if (fields['selectedDirectories'] && !_.isEmpty(fields['selectedDirectories'])) {
			this.setState({sourceSiteInfo: true})
		}
		if (fields['selectedTables'] && !_.isEmpty(fields['selectedTables'])) {
			this.setState({tablesInfo: true})
		}
		if (fields['httpauth_src_user'] || fields['httpauth_src_password']) {
			this.setState({httpAuth: true})
		}
	}

	toggleCwsServer(state) {
		this.setState({cwsServer: state})
	}

	togglePrivacyMode() {
		const { privacyMode } = this.state
		this.setState({privacyMode: !privacyMode})
	}

	toggleSourceSiteInfo() {
		const { sourceSiteInfo } = this.state
		this.setState({sourceSiteInfo: !sourceSiteInfo})
	}

	toggleHttpAuth() {
		const { httpAuth } = this.state
		this.setState({httpAuth: !httpAuth})
	}
	
	toggleTablesInfo = () => {
		const { tablesInfo } = this.state
		this.setState({tablesInfo: !tablesInfo})
	}

	setAdvancedOptionsError(errors){
		if (!_.isEmpty(_.intersection(errors, httpauth_src_fields))){
			this.setState({ httpAuth: true })
		} else if (!_.isEmpty(_.intersection(errors, httpauth_dest_fields))){
			this.setState({ privacyMode: true })
		}
	}

	showDirectoryList() {
		const { directoryList, changeSelection } = this.props
		if (directoryList){
			return directoryList.map((directory, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className="customcheck">{directory.name}
						<input
							name={directory.name}
							type="checkbox"
							checked={directory.selected}
							onChange={changeSelection.bind(null, directory.name)}
							disabled={directory.isDisabled}
						/>
						<span className="checkmark"></span>
					</label>
				</li>
			})
		}
	}
	
	showTablesList = () => {
		const { tablesList, changeTableSelection } = this.props
		if (tablesList) {
			return tablesList.map((table, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className="customcheck">{table.name}
						<input
							name={table.name}
							type="checkbox"
							checked={table.selected}
							onChange={changeTableSelection.bind(null, table.name)}
							disabled={table.isDisabled}
						/>
						<span className="checkmark"></span>
					</label>
				</li>
			})
		}
	}

	render() {
		const { handleSubmit, error, getDirectoryList, fetchingDirectories, getTablesList, fetchingTables } = this.props
		const { cwsServer, privacyMode, sourceSiteInfo, httpAuth, tablesInfo } = this.state
		return <div className="cws">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="migration-box text-center">
							<div>
								<img className="cws-logo" src="/assets/cloudways/cws-migrate.svg" alt=""/>
								<h1 className="font-36 color-0E134F proxima-regular mt-2">Migrate your site to Cloudways</h1>
							</div>
							<div className="cw-border-1 mt-5 mb-5"/>
							<Form className="needs-validation migration-details" onSubmit={handleSubmit}>
								<div className="container-narrow">
									<h5 className="font-20 color-0E134F proxima-regular text-center mb-1">Migrate your site to Cloudways</h5>
									{ error && <div className="pb-2 font12">{error}</div> }
									{ this.canEnableCwsAutoscale() ? <div className="row">
										<div className={this.getClassName('cws-server')}>
											<div className="text-left mt-3">
												<label htmlFor="cws-server">
													Where do you want to migrate your site?
												</label>
												<input type="radio" id="cws-server-flexible" name="cws-server" checked={SERVER.FLEXIBLE == cwsServer} onChange={() => this.toggleCwsServer(SERVER.FLEXIBLE)}/>
												<label htmlFor="cws-server-flexible">Cloudways Flexible</label>
												<input type="radio" data-hide-next id="cws-server-autoscale" name="cws-server" checked={SERVER.AUTOSCALE == cwsServer} onChange={() => this.toggleCwsServer(SERVER.AUTOSCALE)}/>
												<label htmlFor="cws-server-autoscale">Cloudways Autonomous</label>
											</div>
										</div>
									</div> : null }
									<div className="row">
										<div className={this.getClassName('newurl')}>
											<Input
												type="text"
												title="Destination Site URL*"
												name="newurl"
												placeholder="Eg. https://example.cloudwaysapps.com"
												classname=""
												value={this.fetchValue('newurl')}
												required={true}
											/>
										</div>
									</div>
									<div className="row">
										<div className={this.getClassName('newurl')}>
											<Input
												type="text"
												title="SFTP Host/Server Address*"
												name="address"
												placeholder="Eg. 12.34.567.890"
												classname=""
												value={this.fetchValue('address')}
												required={true}
											/>
										</div>
									</div>
									{ SERVER.AUTOSCALE == cwsServer ? <div className="row">
										<div className={this.getClassName('port')}>
											<Input
												type="text"
												title="SFTP Port*"
												name="port"
												placeholder="See Cloudways Platform (Eg. 2200)"
												classname=""
												value={this.fetchValue('port')}
												required={true}
											/>
										</div>
									</div> : null }
									{ SERVER.FLEXIBLE == cwsServer ? <div className="row">
										<div className={this.getClassName('appfolder')}>
											<Input
												type="text"
												name="appfolder"
												title="Database Name"
												placeholder="See Cloudways Platform"
												classname=""
												value={this.fetchValue('appfolder')}
											/>
										</div>
									</div> : null }
									<div className="row">
										<div className={this.getClassName('username')}>
											<Input
												type="text"
												title=" SFTP Username*"
												name="username"
												placeholder="See Cloudways Platform"
												classname=""
												value={this.fetchValue('username')}
												required={true}
											/>
										</div>
									</div>
									<div className="row">
										<div className={this.getClassName('passwd')}>
											<Input
												type="password"
												title="SFTP Password*"
												name="passwd"
												placeholder="See Cloudways Platform"
												classname=""
												value={this.fetchValue('passwd')}
												required={true}
											/>
										</div>
									</div>
									<div className="text-left">
										<label htmlFor="cws-password">
											HTTP Auth enabled?
											<span className="tooltip">
												<img src="/assets/cloudways/cws-info-icon.svg" width={15} className="tooltip__trigger" alt="" />
												<div className="tooltip__body">Is the destination site password protected?</div>
											</span>
										</label>
										<input type="radio" id="cws-auth-enabled-yes" name="cws-auth-enabled" checked={privacyMode} onChange={this.togglePrivacyMode}/>
										<label htmlFor="cws-auth-enabled-yes">Yes</label>
										<input type="radio" data-hide-next id="cws-auth-enabled-no" name="cws-auth-enabled" checked={!privacyMode} onChange={this.togglePrivacyMode}/>
										<label htmlFor="cws-auth-enabled-no">No</label>
										<div data-toggle-section>
											<div className="row">
												<div className={this.getClassName('httpauth_dest_user')}>
													<Input
														type="text"
														title="HTTP Auth Username"
														name="httpauth_dest_user"
														placeholder="Username"
														value={this.fetchValue('httpauth_dest_user')}
													/>
												</div>
											</div>
											<div className="row">
												<div className={this.getClassName('httpauth_dest_password')}>
													<Input
														type="password"
														title="HTTP Auth Password"
														name="httpauth_dest_password"
														placeholder="Password"
														value={this.fetchValue('httpauth_dest_password')}
													/>
												</div>
											</div>
										</div>
									</div>
									<div className="container-narrow text-left">
										<h5 className="font-20 color-0E134F proxima-regular text-center mt-3 mb-3">Source site information</h5>
										<label className="pt-1">
											Any root directories you want to migrate?
										</label>
										<input type="radio" id="source-root-dir-yes" name="source-root-dir" checked={sourceSiteInfo} onClick={getDirectoryList} onChange={this.toggleSourceSiteInfo}/>
										<label className="radio" htmlFor="source-root-dir-yes">Yes</label>
										<input type="radio" data-hide-next id="source-root-dir-no" name="source-root-dir" checked={!sourceSiteInfo} onChange={this.toggleSourceSiteInfo}/>
										<label htmlFor="source-root-dir-no">No</label>

										<div className="mb-3 text-center" data-toggle-section>
											{fetchingDirectories && <img src="/assets/spinner-gray.svg" className="spinning-loader" alt="Loading…"/>}
											{this.showDirectoryList()}
										</div>

										<label className="pt-1">
                      Migrate additional database tables?
										</label>
										<input type="radio" id="tables-info-yes" name="tablesInfo" checked={tablesInfo} onClick={getTablesList} onChange={this.toggleTablesInfo}/>
										<label className="radio" htmlFor="tables-info-yes">Yes</label>
										<input type="radio" id="tables-info-no" name="tablesInfo" checked={!tablesInfo} onChange={this.toggleTablesInfo}/>
										<label className="radio" htmlFor="tables-info-no">No</label>
										
										<div className="text-center" data-toggle-section>
											{fetchingTables && <img src="/assets/spinner-gray.svg" className="spinning-loader" alt="Loading�~@�"/>}
											{tablesInfo && this.showTablesList()}
										</div>

										<label htmlFor="cws-password" className="pt-1">
											Is this site password-protected?
										</label>
										<div>
											<input type="radio" id="source-pm-enabled-yes" name="source-pm-enabled" checked={httpAuth} onChange={this.toggleHttpAuth}/>
											<label className="radio" htmlFor="source-pm-enabled-yes">Yes</label>
											<input type="radio" data-hide-next id="source-pm-enabled-no" name="source-pm-enabled" checked={!httpAuth} onChange={this.toggleHttpAuth}/>
											<label htmlFor="source-pm-enabled-no">No</label>
											<div data-toggle-section>
												<div className="row">
													<div className={this.getClassName('httpauth_src_user')}>
														<Input
															type="text" 
															name="httpauth_src_user"
															title="Username"
															id="source-pm-username" 
															placeholder="Username"
															value={this.fetchValue('httpauth_src_user')}
														/>
													</div>
												</div>
												<div className="row">
													<div className={this.getClassName('httpauth_src_password')}>
														<Input
															type="password"
															title="Password"
															name="httpauth_src_password"
															id="source-pm-password"
															placeholder="Password"
															value={this.fetchValue('httpauth_src_password')}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="row hide-field">
										<Input
											type="hidden"
											name="migrate"
											value="cloudways"
											title=""
											placeholder=""
											classname=""
										/>
										<Input
											type="hidden"
											title=""
											name="type"
											placeholder=""
											classname=""
											value="sftp"
										/>
										<Input
											type="hidden"
											title=""
											name="protocol"
											placeholder=""
											classname=""
											value={PROTOCOL.SFTP}
										/>
										<Input
											type="hidden"
											title=""
											name="is_autoscale"
											placeholder=""
											classname=""
											value={SERVER.AUTOSCALE == cwsServer}
										/>
									</div>
									<div className="text-center">
										<button type="submit" className="green-button mt-5 mb-3 w-50 border-none">MIGRATE</button>
									</div>
								</div>
							</Form>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
}

CloudwaysForm.propTypes = {
	handleSubmit: PropTypes.func,
	fields: PropTypes.object,
	errors: PropTypes.array,
	error: PropTypes.object,
	directoryList: PropTypes.array,
	changeSelection: PropTypes.func,
	getDirectoryList: PropTypes.func,
	fetchingDirectories: PropTypes.bool,
	loading: PropTypes.bool
}

export default CloudwaysForm
